import { useMutation } from "@apollo/react-hooks";
import { SubmitFeedbackInput } from "../../../apollo-types/globalTypes";
import {
  SubmitFeedback,
  SubmitFeedbackVariables,
} from "../../../apollo-types/SubmitFeedback";
import { Topic } from "../../../types/topics";
import { mapTopic } from "../../../utils/map-topics";
import { SEND_FEEDBACK } from "./query";

export const useSubmitFeedback = (topic: Topic) => {
  const [submitFeedbackByTopic] = useMutation<
    SubmitFeedback,
    SubmitFeedbackVariables
  >(SEND_FEEDBACK);

  return {
    submitFeedback: (data: SubmitFeedbackInput) =>
      submitFeedbackByTopic({
        variables: {
          input: {
            topic: mapTopic(topic),
            data,
          },
        },
      }),
  };
};
